import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z"
}), 'LaptopChromebookSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LaptopChromebookSharp.js
// module id = 4404
// module chunks = 2